(() => {
  'use strict';
  const root = document.getElementById('sf-color-story-home');
  const configNode = document.getElementById('sf-home-tracking-config');
  if (!root || !configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  if (config.pageType !== 'index' || String(config.themeId) !== String(config.allowedTheme)) return;
  if (window.__sfHomeTracking) {
    if (window.__sfHomeTracking.root === root) return;
    window.__sfHomeTracking.destroy();
  }
  const sendEnabled = config.sendEnabled === true;
  const controller = new AbortController();
  const options = { signal: controller.signal, passive: true };
  const states = [];
  let last = performance.now();
  let lastInteraction = last;
  let allowed = false;
  let gaReady = false;
  let ownsGoogleTag = false;
  let pageActive = true;
  let destroyed = false;
  let sequence = 0;
  const cleanId = value => String(value || '').replace(/[^a-z0-9_-]/gi, '').slice(0, 80);
  const modules = [
    ['navigation', '.header'], ['hero', '#top'], ['color_stories', '#color-stories'],
    ['yarn', '#yarn'], ['fiveply', '.fiveply'], ['delivery', '#us-warehouse'],
    ['kits', '#kits'], ['patterns', '#patterns'], ['more_options', '.more-ways'], ['footer', '.footer']
  ];
  for (const [id, selector] of modules) {
    const element = root.querySelector(selector);
    if (element) states.push({ id, element, continuous: 0, viewed: false, total: 0, sent: 0 });
  }
  const privacyAllowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  const topLevelConsent = granted => {
    if (typeof window.gtag === 'function' && gaReady && ownsGoogleTag) window.gtag('consent', 'update', { analytics_storage: granted ? 'granted' : 'denied' });
  };
  const loadDestinations = () => {
    if (!sendEnabled || !allowed) return;
    if (!gaReady && /^G-[A-Z0-9]+$/.test(config.measurementId || '')) {
      if (typeof window.gtag !== 'function') {
        ownsGoogleTag = true;
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
        window.gtag('js', new Date());
        window.gtag('config', config.measurementId, {
          send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false,
          page_location: location.origin + location.pathname, page_referrer: '',
          cookie_prefix: config.environment === 'production' ? 'sf_home' : 'sf_home_preview'
        });
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(config.measurementId);
        script.dataset.sfHomeDestination = 'ga4';
        document.head.appendChild(script);
      }
      gaReady = true;
    }
  };
  const emit = (kind, moduleId, detail = {}) => {
    const payload = {
      sf_environment: config.environment, sf_theme_id: String(config.themeId), sf_version: config.version,
      sf_module: cleanId(moduleId), sf_locale: cleanId(config.locale), sf_sequence: ++sequence, ...detail
    };
    const name = config.eventPrefix + '_' + kind + '_' + cleanId(moduleId);
    if (sendEnabled && allowed && privacyAllowed()) {
      if (gaReady && typeof window.gtag === 'function') window.gtag('event', name, {
        ...payload, send_to: config.measurementId,
        page_location: location.origin + location.pathname, page_referrer: '', transport_type: 'beacon',
        value: kind === 'dwell' ? payload.sf_dwell_ms / 1000 : 1
      });
    }
  };
  const flush = () => {
    for (const state of states) {
      const delta = Math.floor(state.total - state.sent);
      if (delta >= 1000) {
        emit('dwell', state.id, { sf_dwell_ms: delta });
        state.sent += delta;
      }
    }
  };
  const viewport = () => {
    const width = document.documentElement.clientWidth;
    const height = window.innerHeight;
    const header = root.querySelector('.header');
    const hr = header?.getBoundingClientRect();
    const fixedHeader = header && /fixed|sticky/.test(getComputedStyle(header).position);
    const top = fixedHeader && hr.bottom > 0 ? Math.min(height, hr.bottom) : 0;
    const preview = document.querySelector('#preview-bar-iframe');
    const pr = preview?.getBoundingClientRect();
    const bottom = pr && pr.top > top && pr.top < height ? pr.top : height;
    return { width, top, bottom, height: bottom - top };
  };
  const eligible = (element, v) => {
    if (!element.isConnected) return false;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || +style.opacity === 0) return false;
    const r = element.getBoundingClientRect();
    const vertical = Math.max(0, Math.min(r.bottom, v.bottom) - Math.max(r.top, v.top));
    const horizontal = Math.max(0, Math.min(r.right, v.width) - Math.max(r.left, 0));
    const denominator = Math.min(r.height, v.height) * Math.min(r.width, v.width);
    return denominator > 0 && vertical * horizontal / denominator >= config.visibleRatio;
  };
  const tick = (time = performance.now()) => {
    if (destroyed) return;
    const previous = last;
    const elapsed = Math.max(0, Math.min(1000, time - previous));
    last = time;
    const foreground = pageActive && !document.hidden && document.hasFocus();
    const measurable = foreground && sendEnabled && allowed && privacyAllowed();
    const overlayOpen = root.querySelector('.sf-home-overlay [role="dialog"]');
    const v = viewport();
    const activeMs = Math.max(0, Math.min(elapsed, lastInteraction + config.idleMs - previous));
    for (const state of states) {
      if (!measurable || overlayOpen || !eligible(state.element, v)) { state.continuous = 0; continue; }
      state.continuous += elapsed;
      if (!state.viewed && state.continuous >= config.viewMs) {
        state.viewed = true;
        emit('view', state.id);
      }
      state.total += activeMs;
    }
  };
  const nearestModule = target => {
    if (target.closest('.sf-home-overlay')) return 'dialog';
    return states.find(s => s.element.contains(target))?.id || 'homepage';
  };
  const click = event => {
    const target = event.target?.closest?.('a,button,select');
    if (!target || !root.contains(target)) return;
    tick();
    lastInteraction = performance.now();
    if (!sendEnabled || !allowed || !privacyAllowed()) return;
    const id = nearestModule(target);
    const detail = {};
    const module = states.find(s => s.id === id);
    if (module) detail.sf_position = [...module.element.querySelectorAll('a,button,select')].indexOf(target) + 1;
    const story = target.closest('article')?.querySelector('[data-story]');
    if (story) detail.sf_story = cleanId(story.dataset.story);
    const article = target.closest('[data-featured-kit],[data-warehouse-product],[data-pattern-inspiration]');
    if (article) detail.sf_product_id = cleanId(article.dataset.featuredKit || article.dataset.warehouseProduct || article.dataset.patternInspiration);
    const pattern = target.closest('[data-kit-pattern]');
    if (pattern) { detail.sf_product_id = cleanId(pattern.dataset.kitPattern); detail.sf_action = 'pattern'; }
    if (target.dataset.storyProduct) detail.sf_variant_id = cleanId(target.dataset.storyProduct);
    if (target.hasAttribute('data-story')) { detail.sf_action = 'open_story'; detail.sf_story = cleanId(target.dataset.story); }
    else if (target.hasAttribute('data-close')) detail.sf_action = 'close_dialog';
    else if (target.hasAttribute('data-home-search')) detail.sf_action = 'open_search';
    else if (target.hasAttribute('data-home-menu')) detail.sf_action = 'toggle_menu';
    else if (target.closest('form')) detail.sf_action = target.closest('#sf-home-language') ? 'language_control' : 'newsletter_control';
    else if (target.tagName === 'A') {
      try {
        const url = new URL(target.getAttribute('href'), location.origin);
        const product = url.pathname.match(/\/products\/([a-z0-9-]+)\/?$/i);
        if (url.origin === location.origin && product) {
          detail.sf_target = product[1].slice(0, 100);
          detail.sf_action = detail.sf_action || (target.closest('.kit-purchase') ? 'kit' : 'product');
        } else if (url.origin === location.origin && /^#[a-z0-9-]+$/i.test(target.getAttribute('href') || '')) {
          detail.sf_target = cleanId(url.hash); detail.sf_action = 'section_link';
        } else detail.sf_action = url.origin === location.origin ? 'internal_link' : 'external_link';
      } catch (_) { detail.sf_action = 'link'; }
    }
    emit('click', id, { sf_action: detail.sf_action || 'control', ...detail });
    const packId = cleanId(target.dataset.sfFiveplyPack);
    const pack = config.fiveplyPacks?.[packId];
    if (id === 'fiveply' && target.matches('.fiveply .pack-option a.button[data-sf-fiveply-pack]') && pack && detail.sf_action === 'product' && detail.sf_target === pack.handle) {
      emit('pack', packId, { ...detail, sf_module: 'fiveply', sf_pack: packId, sf_pack_quantity: pack.quantity });
    }
    flush();
  };
  const privacyChanged = () => {
    const next = privacyAllowed();
    if (allowed && !next) {
      allowed = false;
      states.forEach(state => { state.sent = state.total; });
    } else tick();
    allowed = next;
    for (const state of states) state.continuous = 0;
    loadDestinations();
    if (sendEnabled) topLevelConsent(allowed);
    last = performance.now();
  };
  root.addEventListener('click', click, { ...options, capture: true });
  for (const type of ['pointerdown', 'touchstart', 'keydown', 'scroll']) {
    window.addEventListener(type, event => {
      if (!event.isTrusted) return;
      tick(); lastInteraction = performance.now();
    }, options);
  }
  document.addEventListener('visibilitychange', () => { tick(); flush(); states.forEach(s => { s.continuous = 0; }); }, options);
  window.addEventListener('blur', () => { tick(); flush(); states.forEach(s => { s.continuous = 0; }); }, options);
  window.addEventListener('focus', () => { last = performance.now(); lastInteraction = last; }, options);
  window.addEventListener('pagehide', () => { tick(); flush(); pageActive = false; }, options);
  window.addEventListener('pageshow', () => { pageActive = true; last = performance.now(); lastInteraction = last; }, options);
  document.addEventListener('visitorConsentCollected', privacyChanged, options);
  const timer = setInterval(tick, 250);
  const flushTimer = setInterval(() => { tick(); flush(); }, config.flushMs);
  const destroy = () => {
    tick(); flush(); destroyed = true; controller.abort(); clearInterval(timer); clearInterval(flushTimer);
    if (window.__sfHomeTracking?.root === root) delete window.__sfHomeTracking;
  };
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) destroy(); }, options);
  window.__sfHomeTracking = { root, destroy };
  privacyChanged();
  if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function' && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) privacyChanged(); });
  }
})();
